/**
 * router
 *
 * meta.item
 * 作用于 header 一级导航菜单项底部短线
 */

import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/home/Home.vue';

const getRouter = (store: any) => {
  Vue.use(Router);

  const router = new Router({
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home,
        meta: { line: 'home', hidebar: true },
      },
      {
        path: '/productlist',
        name: 'productlist',
        component: () => import('./views/products/Productlist.vue'),
        meta: { line: 'productlist', hidebar: true },
      },
      {
        path: '/productlist/:id',
        name: 'productdetail',
        component: () => import('./views/products/Productdetail.vue'),
        meta: { line: 'productlist', hidebar: true },
      },
      {
        path: '/machining',
        name: 'machining',
        component: () => import('./views/machining/Machining.vue'),
        meta: { line: 'machining' },
      },
      {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ './views/about/About.vue'),
        meta: { line: 'about' },
      },
      {
        path: '/newslist',
        name: 'newslist',
        component: () => import('./views/news/Newslist.vue'),
        meta: { line: 'newslist', hidebar: true },
      },
      {
        path: '/newslist/:id',
        name: 'newsdetail',
        component: () => import('./views/news/Newsdetail.vue'),
        meta: { line: 'newslist', hidebar: true },
      },
      {
        path: '/contact',
        name: 'contact',
        component: () => import('./views/contact/Contact.vue'),
        meta: { line: 'contact', hidebar: true },
      },
      {
        path: '/single',
        name: 'single',
        component: () => import('./views/single/Single.vue'),
        meta: { line: 'home', hidebar: true },
      },
    ],
  });

  router.beforeEach((to, from, next) => {
    if (to.meta.hidebar) {
      store.commit('setShowbar', false);
    }

    next();
  });

  return router;
};



export default getRouter;
